// src/components/Header.js
import React, { useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom'; // Import Link



const PageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden; // Ensure no scrollbars
`;

const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; // Ensure it's behind the text
`;

const HeaderContainer = styled.div`
  color: #00ff00;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Courier New', monospace;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7); // Semi-transparent background
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  z-index: 2; // Ensure it's above the canvas
`;

const Title = styled.h1`
  font-size: 3rem;
  position: relative;
  color: #00ff00;
  transition: transform 0.3s; // Add transition for smooth scaling

  &:hover {
    transform: scale(1.1); // Scale up the text on hover
  }
`;

const Subtitle = styled.p`
  font-size: 1.5rem;
  color: #00ff00;
  margin-top: 1rem;
`;

const Links = styled.div`
  display: flex;
  gap: 1rem;  // Space between buttons
  margin-top: 1rem;
  background-color: transparent;

`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;  // Space between buttons
  margin-top: 1.5rem;
`;

const Button = styled.a`
  background: transparent;
  color: #00ff00;
  border: 2px solid #00ff00;
  padding: 0.5rem 2rem;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #00ff00;
    color: black;
  }
`;

const Header = () => {
  const [displayedTitle, setDisplayedTitle] = React.useState('');
  const [displayedSubtitle, setDisplayedSubtitle] = React.useState('');
  const [showCursor, setShowCursor] = React.useState(true);
  const titleText = 'Jack Shkifati';
  const subtitleText = 'Software Engineer | AI Engineer | Embedded Engineer';
  const canvasRef = useRef(null);

  React.useEffect(() => {
    // Initial cursor blinking
    let blinkCount = 0;
    const blinkTimer = setInterval(() => {
      setShowCursor(prev => !prev);
      blinkCount++;
      if (blinkCount >= 0) { // Blink 3 times (6 state changes)
        clearInterval(blinkTimer);
        startTyping();
      }
    }, 500);

    const startTyping = () => {
      let titleIndex = 0;
      const titleTimer = setInterval(() => {
        if (titleIndex <= titleText.length) {
          setDisplayedTitle(titleText.slice(0, titleIndex));
          titleIndex++;
        } else {
          clearInterval(titleTimer);
          let subtitleIndex = 0;
          const subtitleTimer = setInterval(() => {
            if (subtitleIndex <= subtitleText.length) {
              setDisplayedSubtitle(subtitleText.slice(0, subtitleIndex));
              subtitleIndex++;
            } else {
              clearInterval(subtitleTimer);
            }
          }, 100); // Slower typing speed for subtitle
        }
      }, 100); // Slower typing speed for title
    };

    return () => {
      clearInterval(blinkTimer);
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const width = canvas.width = window.innerWidth;
    const height = canvas.height = window.innerHeight;
    const columns = Math.floor(width / 20);
    const drops = Array(columns).fill(1);

    const draw = () => {
      context.fillStyle = 'rgba(0, 0, 0, 0.05)';
      context.fillRect(0, 0, width, height);
      context.fillStyle = '#00ff00';
      context.font = '20px monospace';

      drops.forEach((y, index) => {
        const text = String.fromCharCode(Math.floor(Math.random() * 128));
        const x = index * 20;
        context.fillText(text, x, y * 20);

        if (y * 20 > height && Math.random() > 0.975) {
          drops[index] = 0;
        }
        drops[index]++;
      });
    };

    const interval = setInterval(draw, 50);
    return () => clearInterval(interval);
  }, []);

  

  return (
    <PageContainer>
      <Canvas ref={canvasRef} />
      <HeaderContainer>
        <Title>
          {displayedTitle}
          {displayedTitle.length < titleText.length && showCursor ? '_' : ''}
        </Title>
        <Subtitle>
          {displayedSubtitle}
          {displayedSubtitle.length < subtitleText.length ? '_' : ''}
        </Subtitle>
        <Links>
          <a href="https://www.linkedin.com/in/jack-shkifati/" target="_blank">
            <img border="0" alt="W3Schools" src="linkedin2.png" width="50" height="50" ></img>
         </a>
          <a href="https://github.com/JackShkifati28" target="_blank">
            <img border="0" alt="W3Schools" src="git.png" width="50" height="50"></img>
          </a>
         </Links>
        {/* <ButtonContainer>
          <Button as="button" onClick={() => window.location.href = '/resume'}>Resume</Button>
          <Button as="button" onClick={() => window.location.href = '/Projects'}>Projects</Button>
        </ButtonContainer> */}
        <ButtonContainer>
  <Button 
    as="button" 
    type="button"
    onClick={() => window.location.href = '/resume'}
  >
    Resume
  </Button>
  <Button 
    as="button" 
    type="button"
    onClick={() => window.location.href = '/projects'}
  >
    Projects
  </Button>
</ButtonContainer>
      </HeaderContainer>
    </PageContainer>
  );
};

export default Header;
